import React from 'react'
import Layout from '../component/layout'

const ExpenseApprovals = () => {
  return (
    <Layout>
      
    </Layout>
  )
}

export default ExpenseApprovals